<template>
  <div>
    <div class="hello">
<!--      <div class="Head"></div>-->
      <!-- banner图 -->
      <div v-if="wikiDetail.imgUrl!=''">
        <img :src="wikiDetail.imgUrl" class="banimages" />
      </div>
      <!-- 简介 -->
      <div class="BriefIntroduction">
        <div class="BriefIntroductionj">简介</div>
      </div>
      <div class="detailbox">
        <div class="textbox" style="font-weight:0;" v-html="wikiDetail.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { removeParams, removeUser, getToken, setToken, setUid, setIsSystem, removeToken, getCode, getUid, removeCode, removeUid} from 'utils/auth'
import { parseTime, getUrlParam, isWeixin} from 'utils/index'
import { CODE_OK } from 'utils/publicData'
import EnvionmentVariables from '../../../../baseUrl'
// const code = '071Gyf9q1LsSYl00Kbbq1Tnd9q1Gyf94';
const defaultImg = '@/assets/vote/defaultImg.png'
const wx = require('weixin-js-sdk');
export default {
  name: 'todayActivity',
  components: {

  },
  data () {
    return {
      id: 0,
      wikiDetail: {},
      IMAGE_HOST: EnvionmentVariables.IMAGE_HOST
    }
  },
  beforeCreate () {

  },
  created () {
    let title = this.$route.query.title;
    console.log(title + "  -----")
    this.title = title;
    document.title = title;
  },
  mounted () {
    if (this.$route.query.id) this.id = parseInt(this.$route.query.id);
    this.getDetail();
  },
  methods: {
    getDetail () {
      var that = this;
      var param = {
        service: "appagg",
        query: this.id
      }
      this.$api.GetWikiDetial(param).then(res => {
        if (res) {
          that.wikiDetail = res.data.result;
          if (that.wikiDetail) {
            that.wikiDetail.imgUrl =
              (that.wikiDetail.imgUrl&&that.wikiDetail.imgUrl != "")
                ? that.IMAGE_HOST + that.wikiDetail.imgUrl
                : "";
            that.setTitle(that.wikiDetail.title);
          }
        }
      }).catch(err => {
        console.log(err);
      })
    },
    setTitle(title) {
      document.title = title;
    }
  }
}
</script>

<style scoped lang="less">
.Head {
  width: 100%;
  height: 80px;
  background-image: linear-gradient(#2b7cff, #2ba2ff);
  font-size: 30px;
  line-height: 80px;
  color: #fff;
}
.Headtext {
  float: left;
  margin-left: 200px;
}
.back {
  float: left;
  font-size: 28px;
  color: #fff;
  margin-left: 30px;
}
.banimages {
  width: 100%;
  height: 420px;
}
.BriefIntroduction {
  margin: 0 auto;
  width: 95%;
  border-left: 2px solid #2b7cff;
  font-size: 32px;
  overflow: hidden;
  margin-top: 40px;
  margin-left: 30px;
}
.BriefIntroductionj {
  float: left;
  font-weight: bold;
  margin-left: 10px;
}
.textbox {
  padding: 0 30px;
  margin-top: 30px;
  font-size: 28px;
}
.detailbox .textbox img {
  width: 100% !important;
}
</style>
